import React, { useEffect, useRef, useState } from "react";
import API from "../api/Api";
import { BASE_URL } from "../api/Api";
export default function Leader() {
  const [leaders, setLeaders] = useState([]);
  const [loading, setLoading] = useState(true);

  const sliderRef = useRef(null);
  const intervalRef = useRef(null);
  const currentIndex = useRef(0);

  useEffect(() => {
    const fetchLeaders = async () => {
      try {
        const res = await API.get("/leaders");
        setLeaders(res.data.data || []);
      } catch (error) {
        console.error("Leader API Error", error);
      } finally {
        setLoading(false);
      }
    };

    fetchLeaders();
  }, []);

  useEffect(() => {
    if (window.innerWidth > 576 || !leaders.length) return;

    const slider = sliderRef.current;
    if (!slider) return;

    const startAuto = () => {
      intervalRef.current = setInterval(() => {
        const total = slider.children.length;
        const width = slider.clientWidth;

        currentIndex.current =
          (currentIndex.current + 1) % total;

        slider.scrollTo({
          left: currentIndex.current * width,
          behavior: "smooth",
        });
      }, 2500);
    };

    const stopAuto = () => clearInterval(intervalRef.current);

    currentIndex.current = 0;
    slider.scrollTo({ left: 0, behavior: "auto" });

    startAuto();

    return stopAuto;
  }, [leaders]);

  if (loading) return <p>Loading...</p>;

  return (
    <section className="leaders-section">
      <div className="container">
        <div
          className="leaders-grid"
          ref={sliderRef}
        >
          {leaders.map((leader, index) => (
            <div className="leader-card" key={leader.leader_id || index}>
              <div className="leader-img">
                <img
  src={`${BASE_URL}/assets/images/${leader.image}`}
  alt={leader.name}
/>
              </div>
              <div className="leader-name">{leader.name}</div>
              <div className="leader-role">{leader.position}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
